import { render, staticRenderFns } from "./transform-toolbar.vue?vue&type=template&id=1b479d7e&"
import script from "./transform-toolbar.vue?vue&type=script&lang=ts&"
export * from "./transform-toolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports